import type { LeadPolicyDocument, PolicyEditablePayload } from './types';

export const POLICY_EDITABLE_ARRAY_KEYS = ['coverages', 'sums', 'excel_fields', 'attention_points', 'uncertain'] as const;

export type PolicyEditableArrayKey = typeof POLICY_EDITABLE_ARRAY_KEYS[number];

function asObject(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  return value as Record<string, unknown>;
}

export function normalizeEditablePolicyPayload(payload: unknown): PolicyEditablePayload {
  const normalized = { ...(asObject(payload) as PolicyEditablePayload) };

  for (const key of POLICY_EDITABLE_ARRAY_KEYS) {
    const source = Array.isArray((normalized as any)[key]) ? (normalized as any)[key] : [];
    (normalized as any)[key] = source.map((raw: unknown, index: number) => {
      const item = asObject(raw);
      const lineIdRaw = item.line_id;
      const lineId = typeof lineIdRaw === 'string' && lineIdRaw.trim() ? lineIdRaw.trim() : `${key}-${index + 1}`;
      return {
        ...item,
        line_id: lineId,
        disabled: Boolean(item.disabled)
      };
    });
  }

  return normalized;
}

export function toEditablePayloadFromDocument(doc: LeadPolicyDocument): PolicyEditablePayload {
  if (doc.analysis_edit?.payload) {
    return normalizeEditablePolicyPayload(doc.analysis_edit.payload);
  }
  return normalizeEditablePolicyPayload(doc.analysis_payload || {});
}